import { render } from "./ModalEditPdfTemplate.vue?vue&type=template&id=6cfba0e4&scoped=true"
import script from "./ModalEditPdfTemplate.vue?vue&type=script&lang=js"
export * from "./ModalEditPdfTemplate.vue?vue&type=script&lang=js"

import "./ModalEditPdfTemplate.vue?vue&type=style&index=0&id=6cfba0e4&lang=css&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cfba0e4"]])

export default __exports__